import React from 'react';
import LinkConstants from 'constants/LinkConstants';
import CoachingConstants from 'coaching/CoachingConstants';
import Container from 'components/Container';
import Display from 'components/Display';
import Divider from 'components/Divider';
import Image from 'components/Image';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import MediaObject from 'components/MediaObject';
import CoachingHelpSectionHeader from 'coaching/components/CoachingHelpFormView/CoachingHelpSectionHeader';

export default function CoachingHelpArticlesSection() {
  return (
    <Container>
      <CoachingHelpSectionHeader
        icon="book"
        headerText="Get help at your own pace"
        detailText="Prep for your session with these Help Center articles."
      />
      <MediaObject figure="right">
        <Container size="xsmall" align="left">
          {helpArticles.map(({ label, body, href }) => {
            return (
              <React.Fragment key={label}>
                <Row size="small">
                  <Row size="xsmall">
                    <Link href={href} color="ink">
                      <Text size="medium">{label}</Text>
                    </Link>
                  </Row>
                  <Text color="graphite" truncate>
                    {body}
                  </Text>
                </Row>
                <Divider size="small" />
              </React.Fragment>
            );
          })}
        </Container>
        <Display hide="1024">
          <Image width={400} src={require('assets/images/coaching/paper_plane_doodle.png')} />
        </Display>
      </MediaObject>
      {/* Add this back when the coaching help center home page is added */}
      {/* <Link
        href="https://help.remind.com/hc/en-us/categories/201284943-Getting-started"
        color="koolaid">
        <Text size="medium">See all Coaching articles</Text>
      </Link> */}
    </Container>
  );
}

const helpArticles = [
  {
    label: 'How do I share my homework?',
    body:
      'To help your Remind coach customize your coaching sessions, it’s important that the parent or student shares an example of what you want to work on at least 24 hours before your session starts.',
    href: LinkConstants.COACHING_HELP_SHARE_HOMEWORK,
  },
  {
    label: 'How do I set up my devices?',
    body:
      'During a coaching session, students use two different virtual tools: a video chat where they can talk to their coach and a virtual whiteboard where they can write equations, draw graphs, and more.',
    href: LinkConstants.COACHING_HELP_DEVICE_SETUP,
  },
  {
    label: 'What is the scheduling policy?',
    body: CoachingConstants.COACHING_SCHEDULING_HOURS,
    href: LinkConstants.COACHING_HELP_SCHEDULING,
  },
];
